import {ButtonTheme} from 'common/components/button/constants';

export interface SettingsLiAttrs {
  'all-tags': Set<string>;
  button: string;
  'button-icon': string;
  'button-theme': ButtonTheme;
  buttontext: string;
  'custom-handling': boolean;
  'delete-button': boolean;
  disabled: boolean;
  'disabled-message': string;
  editable: boolean;
  editing: boolean;
  emptiable: boolean;
  fileaccept: string;
  'fire-immediate-action': boolean;
  'hide-buttons': boolean;
  isfile: boolean;
  isswitch: boolean;
  label: string;
  placeholder: string;
  'read-only-tags': Set<string>;
  removable: boolean;
  'selected-tags': Set<string>;
  tooltip: string;
  info: string;
  switchon: boolean;
  type: InputType;
  value: string;
  'static-tags': boolean;
}

export interface SettingsLiState {
  editing: boolean;
  password1: string;
  password2: string;
  countryCode: string;
  localPhoneNumber: string;
  type: string;
  isFile: boolean;
  isSwitch: boolean;
  switchOn: boolean;
  allTags: Set<string>;
  readonlyTags: Set<string>;
  selectedTags: Set<string>;
  originalValue: string;
  originalSelectedTags: Set<string>;
  inputValue: string;
  saving: boolean;
  selectItems: any[];
  selectMenuOpen: boolean;
  selectTagOpen: boolean;
  selectedValue: any;
  uploading: boolean;
  saveDisabled: boolean;
  removable: boolean;
  validationError: string;
}

export enum InputType {
  Text = `text`,
  PhoneNumber = `phone-number`,
  MultiSelect = `multi-select`,
  Password = `password`,
  Tag = `tag`,
  Select = `select`,
  File = `file`,
  Slot = `slot`,
}
